/**
 * Stable CSS class names for E2E — OTP Password / Update history.
 */
export const UPH = {
    page: 'otp-password-update-history',
    loadingSection: 'otp-password-update-history__loading-section',

    headerRow: 'otp-password-update-history__header-row',
    title: 'otp-password-update-history__title',
    dateRangeWrap: 'otp-password-update-history__date-range-wrap',
    dateRanger: 'otp-password-update-history-input--date-range',

    tableContainer: 'otp-password-update-history__table-container',
    table: 'otp-password-update-history__table',
    tableHead: 'otp-password-update-history__table-head',
    tableHeadRow: 'otp-password-update-history__table-head-row',
    tableHeadCellCountry: 'otp-password-update-history__table-head-cell--country',
    tableHeadCellArchivedAt: 'otp-password-update-history__table-head-cell--archived-at',
    tableHeadCellUpdatedAt: 'otp-password-update-history__table-head-cell--updated-at',
    tableHeadCellUpdatedUserId: 'otp-password-update-history__table-head-cell--updated-user-id',

    accordionsWrap: 'otp-password-update-history__accordions-wrap',
    accordion: 'otp-password-update-history__accordion',
    accordionSummary: 'otp-password-update-history__accordion-summary',
    accordionExpandIcon: 'otp-password-update-history__accordion-expand-icon',
    accordionSummaryLayout: 'otp-password-update-history__accordion-summary-layout',
    summaryCountryCol: 'otp-password-update-history__summary-country-col',
    summaryCountryFlagImg: 'otp-password-update-history__summary-country-flag-img',
    summaryCountryText: 'otp-password-update-history__summary-country-text',
    summaryArchivedAtCol: 'otp-password-update-history__summary-archived-at-col',
    summaryArchivedAtText: 'otp-password-update-history__summary-archived-at-text',
    summaryUpdatedAtCol: 'otp-password-update-history__summary-updated-at-col',
    summaryUpdatedAtText: 'otp-password-update-history__summary-updated-at-text',
    summaryUpdatedUserIdCol: 'otp-password-update-history__summary-updated-user-id-col',
    summaryUpdatedUserIdText: 'otp-password-update-history__summary-updated-user-id-text',

    accordionDetails: 'otp-password-update-history__accordion-details',
    detailsInner: 'otp-password-update-history__details-inner',

    nestedAccordion: 'otp-password-update-history__nested-accordion',
    nestedAccordionSummary: 'otp-password-update-history__nested-accordion-summary',
    nestedAccordionExpandIcon: 'otp-password-update-history__nested-accordion-expand-icon',
    nestedAccordionSummaryLayout: 'otp-password-update-history__nested-accordion-summary-layout',
    nestedEndpointCol: 'otp-password-update-history__nested-endpoint-col',
    nestedEndpointLabel: 'otp-password-update-history__nested-endpoint-label',
    nestedEndpointValue: 'otp-password-update-history__nested-endpoint-value',
    nestedPlatformCol: 'otp-password-update-history__nested-platform-col',
    nestedPlatformLabel: 'otp-password-update-history__nested-platform-label',
    nestedPlatformValue: 'otp-password-update-history__nested-platform-value',

    nestedAccordionDetails: 'otp-password-update-history__nested-accordion-details',
    hoursGrid: 'otp-password-update-history__hours-grid',
    hourTooltip: 'otp-password-update-history__hour-tooltip',
    hourCard: 'otp-password-update-history__hour-card',
    hourCardInnerTop: 'otp-password-update-history__hour-card-inner-top',
    hourTimeText: 'otp-password-update-history__hour-time-text',
    hourDivider: 'otp-password-update-history__hour-divider',
    hourCardInnerBottom: 'otp-password-update-history__hour-card-inner-bottom',
    hourLimitText: 'otp-password-update-history__hour-limit-text',
} as const;

export const uphCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

